import React from "react";
import AllFieldsPage from "./AllFieldsPage";

function FieldPage() {
  return <AllFieldsPage></AllFieldsPage>;
}

export default FieldPage;
